import React from "react";
import {
  FileText,
  Building2,
  Mail,
  Phone,
  MapPin,
  Scale,
  Shield,
  Globe,
} from "lucide-react";

const MentionsLegalesPage = () => {
  return (
    <div className="min-h-screen bg-[#0f172a] text-white">
      {/* HERO */}
      <section className="border-b border-white/10 bg-[#111827]">
        <div className="max-w-5xl mx-auto px-6 py-16">
          <div className="flex items-center gap-3 mb-5">
            <div className="p-3 rounded-xl bg-blue-500/10 text-blue-400">
              <FileText size={28} />
            </div>

            <span className="text-sm font-semibold uppercase tracking-wider text-blue-400">
              Informations légales
            </span>
          </div>

          <h1 className="text-4xl md:text-5xl font-bold mb-5">
            Mentions légales
          </h1>

          <p className="text-gray-400 max-w-3xl text-lg">
            Les présentes mentions légales permettent d'identifier clairement
            l'exploitant du site et de fournir les informations nécessaires
            concernant l'utilisation de la plateforme.
          </p>

          <p className="text-gray-500 text-sm mt-6">
            Dernière mise à jour : octobre 2026
          </p>
        </div>
      </section>

      {/* CONTENT */}
      <main className="max-w-5xl mx-auto px-6 py-14 space-y-12">

        {/* 1 */}
        <section>
          <div className="flex items-center gap-3 mb-5">
            <Building2 className="text-blue-400" size={24} />
            <h2 className="text-2xl font-bold">
              1. Éditeur du site
            </h2>
          </div>

          <div className="bg-white/5 border border-white/10 rounded-2xl p-6 space-y-3 text-gray-300">
            <p>
              <strong className="text-white">Raison sociale :</strong>{" "}
              [Lexata]
            </p>

            <p>
              <strong className="text-white">Forme juridique :</strong>{" "}
              [A mon compte]
            </p>

            <p>
              <strong className="text-white">Adresse :</strong>{" "}
              [6 avenue des communes reunies], [1212] [Lancy], Suisse
            </p>



            <p>
              <strong className="text-white">E-mail :</strong>{" "}
              <a
                href="mailto:[EMAIL]"
                className="text-blue-400 hover:text-blue-300"
              >
                [leilalexata@gmail.com]
              </a>
            </p>

            <p>
              <strong className="text-white">Téléphone :</strong>{" "}
              [0762957688]
            </p>
          </div>
        </section>

        {/* 2 */}
        <section>
          <div className="flex items-center gap-3 mb-5">
            <Globe className="text-blue-400" size={24} />
            <h2 className="text-2xl font-bold">
              2. Site internet
            </h2>
          </div>

          <div className="space-y-4 text-gray-300 leading-7">
            <p>
              Le présent site internet est accessible à l'adresse :
            </p>

            <p className="text-blue-400 font-medium">
              [https://www.lexata.ch]
            </p>

            <p>
              Le site permet notamment de consulter, acheter et accéder à des
              contenus numériques, notamment des vidéos et, le cas échéant,
              d'autres produits ou services proposés par l'éditeur.
            </p>
          </div>
        </section>

        {/* 3 */}
        <section>
          <div className="flex items-center gap-3 mb-5">
            <Scale className="text-blue-400" size={24} />
            <h2 className="text-2xl font-bold">
              3. Droit applicable
            </h2>
          </div>

          <div className="space-y-4 text-gray-300 leading-7">
            <p>
              Le site et son contenu sont exploités conformément au droit
              suisse, sous réserve des dispositions impératives applicables
              dans le pays de résidence du consommateur lorsque celles-ci
              doivent être respectées.
            </p>

            <p>
              Les présentes mentions légales sont complétées, le cas échéant,
              par les Conditions Générales de Vente et la Politique de
              confidentialité disponibles sur le site.
            </p>
          </div>
        </section>

        {/* 4 */}
        <section>
          <div className="flex items-center gap-3 mb-5">
            <FileText className="text-blue-400" size={24} />
            <h2 className="text-2xl font-bold">
              4. Propriété intellectuelle
            </h2>
          </div>

          <div className="space-y-4 text-gray-300 leading-7">
            <p>
              Sauf indication contraire, l'ensemble des éléments présents sur
              le site est protégé par les dispositions applicables en matière
              de propriété intellectuelle.
            </p>

            <p>
              Cela comprend notamment les textes, photographies, vidéos,
              illustrations, graphiques, logos, marques, interfaces,
              éléments visuels, contenus audio, logiciels, codes, bases de
              données et éléments de conception du site.
            </p>

            <p>
              Toute reproduction, représentation, modification, adaptation,
              extraction, distribution, republication ou exploitation non
              autorisée de tout ou partie du site ou de ses contenus est
              interdite.
            </p>

            <p>
              L'achat d'un contenu numérique ne transfère aucun droit de
              propriété intellectuelle au client. Les conditions d'utilisation
              des vidéos et autres contenus sont précisées dans les CGV.
            </p>
          </div>
        </section>

        {/* 5 */}
        <section>
          <div className="flex items-center gap-3 mb-5">
            <Shield className="text-blue-400" size={24} />
            <h2 className="text-2xl font-bold">
              5. Protection des données
            </h2>
          </div>

          <div className="space-y-4 text-gray-300 leading-7">
            <p>
              Les données personnelles des utilisateurs sont traitées
              conformément à la législation suisse applicable en matière de
              protection des données.
            </p>

            <p>
              Les informations détaillées relatives à la collecte, à
              l'utilisation, à la conservation et à la protection des données
              personnelles sont disponibles dans notre Politique de
              confidentialité.
            </p>
          </div>
        </section>

        {/* 6 */}
        <section>
          <div className="flex items-center gap-3 mb-5">
            <Mail className="text-blue-400" size={24} />
            <h2 className="text-2xl font-bold">
              6. Contact
            </h2>
          </div>

          <div className="bg-white/5 border border-white/10 rounded-2xl p-6 space-y-4 text-gray-300">
            <p>
              Pour toute question concernant le site, les contenus, les
              commandes ou les présentes informations légales :
            </p>

            <p className="flex items-center gap-3">
              <Mail size={18} className="text-blue-400" />
              <a
                href="mailto:[EMAIL]"
                className="text-blue-400 hover:text-blue-300"
              >
                [EMAIL]
              </a>
            </p>

            <p className="flex items-center gap-3">
              <Phone size={18} className="text-blue-400" />
              [NUMÉRO DE TÉLÉPHONE]
            </p>

            <p className="flex items-center gap-3">
              <MapPin size={18} className="text-blue-400" />
              [ADRESSE COMPLÈTE]
            </p>
          </div>
        </section>

        {/* 7 */}
        <section className="border-t border-white/10 pt-10">
          <h2 className="text-2xl font-bold mb-5">
            7. Disponibilité du site
          </h2>

          <div className="space-y-4 text-gray-300 leading-7">
            <p>
              L'éditeur met en œuvre des moyens raisonnables afin de maintenir
              le site accessible et fonctionnel.
            </p>

            <p>
              Toutefois, aucune garantie de disponibilité permanente ne peut
              être donnée. Le site peut notamment être temporairement
              inaccessible en raison de travaux de maintenance, de mises à
              jour, de problèmes techniques, de pannes de réseau ou de tout
              autre événement indépendant de la volonté de l'éditeur.
            </p>
          </div>
        </section>

        {/* 8 */}
        <section className="border-t border-white/10 pt-10">
          <h2 className="text-2xl font-bold mb-5">
            8. Modification des informations
          </h2>

          <p className="text-gray-300 leading-7">
            L'éditeur se réserve le droit de modifier les présentes mentions
            légales lorsque cela est nécessaire, notamment en cas d'évolution
            du site, de l'entreprise ou de la législation applicable.
          </p>
        </section>

      </main>
    </div>
  );
};

export default MentionsLegalesPage;